/**
 * Der Durchführungsmodus (§20.2, §20.3).
 *
 * Eine **einzige** Auskunft für die beiden Live-Ansichten der Verwaltung: Dashboard und
 * Durchführung. Sie zeigen dasselbe Geschehen in unterschiedlicher Tiefe; zwei fast gleiche
 * Endpunkte wären zwei Stellen, an denen dieselben Regeln richtig sein müssten.
 *
 * **Was dieser Typ bewusst nicht hat:** ein Feld für die Stimmenverteilung. Solange eine
 * Abstimmung geöffnet ist, gibt es über keine reguläre Schnittstelle Stimmen je Option,
 * Prozentwerte oder führende Optionen (§16). Die Beteiligungszahlen aus §15 sind ausdrücklich
 * etwas anderes: Sie sagen, wie viele abgestimmt haben, nicht wofür.
 */
/** Pfad des Durchführungsstands in der API (§23.1). */
export const DURCHFUEHRUNG_PATH = '/api/v1/admin/durchfuehrung';
//# sourceMappingURL=durchfuehrung.js.map